export const T = {
  en_GB: {
    // Previous answer
    previousAnswerFound: "Previous Answer Found",
    answeredOn: (date: string) => `You completed verification on ${date}`,
    applying: "Applying...",
    usePreviousAnswer: "Use Previous Answer",
    startFresh: "Start Fresh",
    startVerification: "Start Verification",
    cancel: "Cancel",
    startNewTest: "Start New Test",
    refetching: "Refetching",
    refetchResult: "Refetch result",
    verification: "Verification",
    failedToGenerateToken: "Failed to generate access token",
    verificationNoLongerActive:
      "This verification is no longer active. It may have been replaced by a newer attempt. Start a new test to continue.",
    sumsubDisabledError:
      "Identity verification is currently unavailable. Please contact your advisor.",
    sumsubNotConfiguredError:
      "Identity verification is not configured. Please contact your advisor.",
    unexpectedError: "An unexpected error occurred",
    verificationError: "Verification error:",
    unknownError: "Unknown error",
    incompleteMessage: "Complete the identity verification",
    repNote: (name: string) =>
      `Identity verification is performed for ${name}, who acts on behalf of the client.`,
    repGeneric: "the client's representative",
    reuseNoLongerAvailable: "Reuse is no longer available.",
    // Re-verification (test→production mode switch)
    reVerificationRequired: "Re-verification required",
    reVerificationExplanation:
      "This result was verified in test mode. Run the verification again against the production environment before completing.",
    reVerify: "Re-verify",
  },
  nb_NO: {
    // Previous answer
    previousAnswerFound: "Tidligere svar funnet",
    answeredOn: (date: string) => `Du fullførte verifisering den ${date}`,
    applying: "Bruker...",
    usePreviousAnswer: "Bruk tidligere svar",
    startFresh: "Start på nytt",
    startVerification: "Start verifisering",
    cancel: "Avbryt",
    startNewTest: "Start ny test",
    refetching: "Henter på nytt",
    refetchResult: "Hent resultat på nytt",
    verification: "Verifisering",
    failedToGenerateToken: "Kunne ikke generere tilgangstoken",
    verificationNoLongerActive:
      "Denne verifiseringen er ikke lenger aktiv. Den kan ha blitt erstattet av et nyere forsøk. Start en ny test for å fortsette.",
    sumsubDisabledError:
      "Identitetsverifisering er for øyeblikket utilgjengelig. Kontakt rådgiveren din.",
    sumsubNotConfiguredError: "Identitetsverifisering er ikke konfigurert. Kontakt rådgiveren din.",
    unexpectedError: "En uventet feil oppstod",
    verificationError: "Verifiseringsfeil:",
    unknownError: "Ukjent feil",
    incompleteMessage: "Fullfør identitetsverifiseringen",
    repNote: (name: string) =>
      `Identitetsverifiseringen utføres for ${name}, som handler på vegne av kunden.`,
    repGeneric: "kundens representant",
    reuseNoLongerAvailable: "Gjenbruk er ikke lenger tilgjengelig.",
    // Re-verification (test→production mode switch)
    reVerificationRequired: "Ny verifisering kreves",
    reVerificationExplanation:
      "Dette resultatet ble verifisert i testmodus. Kjør verifiseringen på nytt mot produksjonsmiljøet før fullføring.",
    reVerify: "Verifiser på nytt",
  },
} as const;
